module.exports = __webpack_public_path__ + "static/media/TwitterNegative1_1_.4d0a9707.svg";